import { createContext, useState } from "react";

export const dataa = createContext();

export default function Data ({children}) {    
    const [scene, setScene] = useState([]);

    const [investors, setInvestors] = useState([])
    const [category, setCategory] = useState([])
    const [products,setProducts] = useState([]);
    const [invoices, setInvoices] = useState([])
    const [employees, setEmployees] = useState([]);
    const [showData, setShowData] = useState([]);
    const [batches, setBatches] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [paymentStatus, setPaymentStatus] = useState({});

    const parent = {
        products,
        setProducts,
        category, 
        setCategory,
        investors, 
        setInvestors,
        invoices,
        setInvoices,
        employees, 
        setEmployees,
        scene, 
        setScene,
        showData, 
        setShowData,
        paymentStatus, 
        setPaymentStatus,
        batches, setBatches,
        suppliers, setSuppliers
    }
    return <dataa.Provider value={parent}>{children}</dataa.Provider>
}